<template>
  <v-page page="techCheck">
    <v-layout>
      <v-flex class="py-5 text-xs-center" v-show="iframeLoading">
        <v-progress-circular
          class="mt-5"
          :size="100"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </v-flex>
      <v-flex v-show="!iframeLoading">
        <vue-friendly-iframe
          @document-load="onLoad"
          ref="iframe"
          :src="redashUrl"
          frameborder="0"
          className="iframe" />
      </v-flex>
    </v-layout>
  </v-page>
</template>

<script>
import VPage from '@/layouts/Default'
import VueFriendlyIframe from 'vue-friendly-iframe'

const REDASH_URL = 'https://redash.imbellus.com/dashboard/tech-check?fullscreen'

export default {
  name: 'TechCheck',
  components: {
    VPage,
    VueFriendlyIframe
  },
  data () {
    return {
      iframeLoading: true,
      redashUrl: REDASH_URL
    }
  },
  methods: {
    onLoad () {
      setTimeout(() => {
        this.iframeLoading = false
      }, 500)
    }
  }
}
</script>

<style lang="sass">
.iframe
  width: 100%
  height: calc(100vh - 120px)
</style>
